import { DateTime } from "luxon";


// ESTANDARIZAR FUNCIONES DE FLECHA O UTILIZAR LIBRERIA MOMENTX
const days = [
    {
        "day": 0,
        "codeEn": "sun",
        "en": "Sunday.",
        "es": "Domingo",
        "codeEs": "Dom"
    },
    {
        "day": 1,
        "codeEn": "mon",
        "en": "Monday.",
        "es": "Lunes",
        "codeEs": "Lun"
    },
    {
        "day": 2,
        "codeEn": "tue",
        "en": "Tuesday.",
        "es": "Martes",
        "codeEs": "Mar"
    },
    {
        "day": 3,
        "codeEn": "wed",
        "en": "Wednesday.",
        "es": "Miércoles",
        "codeEs": "Mie"
    },
    {
        "day": 4,
        "codeEn": "thu",
        "en": "Thursday.",
        "es": "Jueves",
        "codeEs": "Jue"
    },
    {
        "day": 5,
        "codeEn": "fri",
        "en": "Friday.",
        "es": "Viernes",
        "codeEs": "Vie"

    },
    {
        "day": 6,
        "codeEn": "sat",
        "en": "Saturday.",
        "es": "Sábado",
        "codeEs": "Sab"
    }
]


const mounths = [
    {
        month: 0,
        en: 'January',
        codeEn: 'Jan',
        es: 'Enero',
        codeEs: 'Ene'
    },
    {
        month: 1,
        en: 'February',
        codeEn: 'Jan',
        es: 'Febrero',
        codeEs: 'Feb'
    },
    {
        month: 2,
        en: 'March',
        codeEn: 'Mar',
        es: 'Marzo',
        codeEs: 'Mar'
    },
    {
        month: 3,
        en: 'April',
        codeEn: 'Apr',
        es: 'Abril',
        codeEs: 'Abr'
    },
    {
        month: 4,
        en: 'May',
        codeEn: 'May',
        es: 'Mayo',
        codeEs: 'May'
    },
    {
        month: 5,
        en: 'June',
        codeEn: 'June',
        es: 'Junio',
        codeEs: 'Jun'
    },
    {
        month: 6,
        en: 'July',
        codeEn: 'July',
        es: 'Julio',
        codeEs: 'Jul'
    },
    {
        month: 7,
        en: 'August',
        codeEn: 'Aug',
        es: 'Agosto',
        codeEs: 'Ago'
    },
    {
        month: 8,
        en: 'September',
        codeEn: 'Sept',
        es: 'Septiembre',
        codeEs: 'Sep'
    },
    {
        month: 9,
        en: 'October',
        codeEn: 'Oct',
        es: 'Octubre',
        codeEs: 'Oct'
    },
    {
        month: 10,
        en: 'November',
        codeEn: 'Nov',
        es: 'Noviembre',
        codeEs: 'Nov'
    },
    {
        month: 11,
        en: 'December',
        codeEn: 'Dec',
        es: 'Diciembre',
        codeEs: 'Dic'
    },
]

// obtener fechas de produccion
export const getDatesProduccion = (date) => {
    const d1 = DateTime.fromJSDate(date[0]);
    const d2 = DateTime.fromJSDate(date[1]).plus({ days: 1 });
    return {
        fecha1: d1.toSQLDate() + ' 7:00:00 AM',
        fecha2: d2.toSQLDate() + ' 6:59:59 PM',
        Fecha1: d1.toSQLDate() + ' 7:00:00 AM',
        Fecha2: d2.toSQLDate() + ' 6:59:59 PM',
        desde: d1.toSQLDate() + ' 7:00:00 AM',
        hasta: d2.toSQLDate() + ' 6:59:59 PM',
    }
}

export const getDatesProduccionOutHours = (date) => {
    const d1 = DateTime.fromJSDate(date[0]);
    const d2 = DateTime.fromJSDate(date[1]).plus({ days: 1 });
    return {
        fecha1: d1.toSQLDate(),
        fecha2: d2.toSQLDate(),
        Fecha1: d1.toSQLDate(),
        Fecha2: d2.toSQLDate(),
        desde: d1.toSQLDate(),
        hasta: d2.toSQLDate(),
    }
}

// convert fecha y hora to string con formato DD/MM/YYYY HH:MM:SS AM/PM
export const getDateTimeString = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return d.toFormat('dd/MM/yyyy hh:mm:ss a');
}

export const getDateTimeString24 = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return d.toFormat('dd/MM/yyyy HH:mm:ss');
}

// convert fecha y hora to string con formato MM/DD/YYYY HH:MM:SS
export const getDateTimeStringSQL = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return d.toFormat('MM/dd/yyyy hh:mm:ss');
}

export const getDateTimeStringSQL24 = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return d.toFormat('MM/dd/yyyy HH:mm:ss');
}


// convertir fecha to string con formato DD/MM/YYYY
export const getDateString = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return d.toLocaleString(DateTime.DATE_SHORT);
    
}

export const getDateStringCeros = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return  d.toFormat('dd/MM/yyyy');
}

export const getDateString2 = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    return d.toFormat('MM/dd/yyyy')
}

export const getFechaTextSmall = (date) => {
    const d = new Date(date);
    return days.filter(e => e.day === d.getDay())[0].codeEs + ', ' + d.getDate() + ' ' + mounths.filter(m => m.month === d.getMonth())[0].codeEs + ', ' + d.getFullYear()
}

export const getFechaFormatoLarge = (date) => {
    const d = new Date(date);
    return days.filter(e => e.day === d.getDay())[0].es + ', ' + d.getDate() + ' ' + mounths.filter(m => m.month === d.getMonth())[0].es + ' de ' + d.getFullYear()
}

export const getDateTextSmall = (date) => {
    const d = new Date(date);
    return d.getDate() + ' de ' + mounths.filter(m => m.month === d.getMonth())[0].es + ' de ' + d.getFullYear()
}

export const getDateTextSmallIdioma = (date, Idioma) => {
    const d = new Date(date);
    if (Idioma === 'es') {
        // console.log(Idioma)
        return d.getDate() + ' de ' + mounths.filter(m => m.month === d.getMonth())[0]?.es + ' de ' + d.getFullYear()
    } else {
        return mounths.filter(m => m.month === d.getMonth())[0]?.en + ' ' + d.getDate() + ' , ' + d.getFullYear()
    }
}

export const DiasEnIngles = (day) => {

    if (day < 1 || day > 31 || isNaN(day)) {
        return "Invalid day";
    }

    const suffixes = ["th", "st", "nd", "rd"];
    const mod10 = day % 10;
    const mod100 = day % 100;

    let suffix = suffixes[0];

    if (mod10 === 1 && mod100 !== 11) {
        suffix = suffixes[1];
    } else if (mod10 === 2 && mod100 !== 12) {
        suffix = suffixes[2];
    } else if (mod10 === 3 && mod100 !== 13) {
        suffix = suffixes[3];
    }

    return `${day}${suffix}`;
}

export const getDateTextReporteIdioma = (date, Idioma) => {
    const d = new Date(date);
    let dia = d.getDate() < 10 ? '0' + d.getDate().toString() : d.getDate()
    if (Idioma === 'es') {
        return dia + ' días del mes de ' + mounths.filter(m => m.month === d.getMonth())[0].es + ' de ' + d.getFullYear()
    } else {
        let formatoDia = DiasEnIngles(dia)
        return formatoDia + ' day of ' + mounths.filter(m => m.month === d.getMonth())[0].en + ' ' + d.getDate() + ' , ' + d.getFullYear()
    }
}

export const getDateTextReporteContrato = (date, Idioma) => {
    const d = new Date(date);
    let dia = d.getDate() < 10 ? '0' + d.getDate().toString() : d.getDate()
    if (Idioma === 'es') {
        return dia + ' días del mes de ' + mounths.filter(m => m.month === d.getMonth())[0].es + ' del año ' + d.getFullYear()
    } else {
        let formatoDia = DiasEnIngles(dia)
        return formatoDia + ' day of ' + mounths.filter(m => m.month === d.getMonth())[0].en + ' ' + d.getDate() + ' , ' + d.getFullYear()
    }
}




export const getDatesProduccionNormal = (date) => {
    const d1 = DateTime.fromJSDate(date[0]);
    const d2 = DateTime.fromJSDate(date[1]);
    return [
        d1.toSQLDate() + ' 7:00:00 AM',
        d2.toSQLDate() + ' 6:59:59 AM'
    ]
}

export const getFechaProduccion = (date) => {
    const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
    const nueva = d.set({ hours: 6, minutes: 59, seconds: 59 })
    return nueva.toFormat('MM/dd/yyyy hh:mm:ss');
}

export const getDatesHorarioNormal = (date) => {
    const d1 = DateTime.fromJSDate(date[0]);
    const d2 = DateTime.fromJSDate(date[1]);
    return [
        d1.toSQLDate(),
        d2.toSQLDate() + ' 11:59: 00 PM'
    ]
}

export const getDateTextIdiomaAbr = (date, Idioma) => {
    const d = new Date(date);
    if (Idioma === 'es') {
        return d.getDate() + ' - ' + mounths.filter(m => m.month === d.getMonth())[0]?.codeEs + ' - ' + ((d.getFullYear()).toString()).slice(-2)
    } else {
        return d.getDate() + '-' + mounths.filter(m => m.month === d.getMonth())[0]?.codeEn + '-' + ((d.getFullYear()).toString()).slice(-2)
    }
}

export const getMontName = (date, Idioma) => {
    const d = new Date(date);
    if (Idioma === 'es') {
        return mounths.filter(m => m.month === d.getMonth())[0]?.es
    } else {
        return mounths.filter(m => m.month === d.getMonth())[0]?.en
    }
}

export const agregarMeses = (date, meses) =>{
    const fecha =  DateTime.fromJSDate(date)?.plus({ months: meses })?.toJSDate();
    return fecha

}
